import {
  GET_PRICE_OFFERS_SUCCESS,
  GET_PRICE_OFFERS_FAILURE,
} from '../../../../config/constants/ActionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case GET_PRICE_OFFERS_SUCCESS: {
      return {
        ...state,
        priceOffers: action.payload.priceOffers,
      }
    }

    case GET_PRICE_OFFERS_FAILURE: {
      return {
        ...state,
        getPriceOffersError: action.payload.error,
      }
    }

    default:
      return state
  }
}
